import { render, staticRenderFns } from "./DishLibrary.vue?vue&type=template&id=077577b6&scoped=true"
import script from "./DishLibrary.vue?vue&type=script&lang=js"
export * from "./DishLibrary.vue?vue&type=script&lang=js"
import style0 from "./DishLibrary.vue?vue&type=style&index=0&id=077577b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077577b6",
  null
  
)

export default component.exports